// @flow
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import type { PostItem } from 'store/modules/listing';
import type { State } from '../../../store';
import './SearchAutoComplete.scss';

type Props = {
  result: ?{
    count: number,
    data: PostItem[],
  },
  onSearchNext: () => any,
  resetState: () => any,
  goProduct: () => any,
  onPointer: () => any,
  menu: string,
  history: any,
  currentKeyword: string,
};

type SelectState = {
  selectedIndex: number,
};

class SearchAutoComplete extends Component<Props, SelectState> {
  state = {
    selectedIndex: -1, // 초기 선택된 항목
  };

  handleKeyDown = (e: KeyboardEvent) => {
    const { selectedIndex } = this.state;
    const { autoComplete } = this.props;

    if (!autoComplete) return;

    // 각 섹션의 항목 수를 모두 합친 총 항목 수 계산
    const totalItems = autoComplete.data.reduce((acc, section) => acc + section.hits.length, 0);

    if (e.key === 'ArrowDown') {
      // 인풋 엔터 막기
      this.props.onPointer(false);
      // 아래 방향키
      this.setState({
        selectedIndex: (selectedIndex + 1) % totalItems, // 마지막 항목에서 아래로 가면 처음으로 돌아감
      });
    } else if (e.key === 'ArrowUp') {
      // 인풋 엔터 막기
      this.props.onPointer(false);
      // 위 방향키
      this.setState({
        selectedIndex: (selectedIndex - 1 + totalItems) % totalItems, // 첫 번째 항목에서 위로 가면 마지막으로 돌아감
      });
    } else if (e.key === 'Enter') {
      // 엔터키 눌렀을 때, 선택된 항목 클릭 처리
      this.handleSelectItem();
    }
  };

  handleSelectItem = () => {
    const { autoComplete } = this.props;
    const { selectedIndex } = this.state;

    if (!autoComplete) return;

    let currentIndex = 0;

    // 선택된 항목을 클릭하도록 이동
    // eslint-disable-next-line no-restricted-syntax
    for (let section of autoComplete.data) {
      // eslint-disable-next-line no-restricted-syntax
      for (let item of section.hits) {
        if (currentIndex === selectedIndex) {
          // 항목을 클릭
          this.clickItem(item, section.indexUid);
          return;
        }
        // eslint-disable-next-line no-plusplus
        currentIndex++;
      }
    }
  };

  clickItem = (item, section) => {
    // 항목 클릭 처리 (Link 이동)
    if (section === 'title_part_number') {
      // 제품 링크
      this.props.history.push(`/@${item.username}/products/${item.url_slug}`);
    } else if (section === 'product_price') {
      // 카탈로그 번호
      this.props.goProduct(item.fk_product_id, item.part_number);
    } else if (section === 'categories') {
      // 카테고리 - 검색 페이지로 이동
      this.props.history.push(`/search?q=&menu=products&facets=${encodeURIComponent(JSON.stringify({ categories: item.title }))}`);
    } else if (section === 'brands') {
      // 브랜드
      this.props.history.push(`/search?q=&menu=products&facets=${encodeURIComponent(JSON.stringify({ brand: item.title }))}`);
    } else if (section === 'posts') {
      // 블로그
      this.props.history.push(`/@${item.username}/${item.url_slug}`);
    }
    this.props.resetState();
  };

  componentDidMount() {
    window.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  }

  // 마우스가 항목 위에 올라갔을 때, 선택된 항목의 인덱스를 변경
  handleMouseEnter = (index: number) => {
    this.setState({
      selectedIndex: index, // 마우스가 올라간 항목의 인덱스로 설정
    });
  };

  // 마우스가 검색 결과 영역을 벗어났을 때, 선택된 인덱스를 초기화
  handleMouseLeave = () => {
    this.props.onPointer(false);
    this.setState({
      selectedIndex: -1, // 선택된 인덱스를 초기화
    });
  };

  renderSearchHistory() {
    const { autoComplete } = this.props;
    const { selectedIndex } = this.state;

    if (!autoComplete) return null;

    let currentIndex = 0;

    return (
      <div onMouseLeave={this.handleMouseLeave}>
        {autoComplete.data[0].hits.length ||
        autoComplete.data[1].hits.length ||
        autoComplete.data[2].hits.length ||
        autoComplete.data[3].hits.length ||
        autoComplete.data[4].hits.length ? (
          <div>
            {autoComplete.data[0].hits.length ? (
              <div>
                <p className="sections-first">제품</p>
                {autoComplete.data[0].hits.map((data, idx) => {
                  const isSelected = currentIndex === selectedIndex;
                  // eslint-disable-next-line no-plusplus
                  currentIndex++;
                  return (
                    // eslint-disable-next-line react/no-array-index-key
                    <li
                      key={`${idx}-${data.url_slug}`}
                      className={`data ${isSelected ? 'selected' : ''}`}
                      onMouseEnter={() => this.handleMouseEnter(idx)}
                    >
                      <Link
                        className="wrapper"
                        to={`/@${data.username}/products/${data.url_slug}`}
                        onClick={this.props.resetState}
                      >
                        <span
                          className="title"
                          dangerouslySetInnerHTML={{ __html: data._formatted.title }}
                        ></span>
                        <br />
                        <span
                          className="part-number"
                          dangerouslySetInnerHTML={{ __html: data._formatted.part_number }}
                        ></span>
                        <span
                          className="cas-number"
                          dangerouslySetInnerHTML={{ __html: data._formatted.cas_number }}
                        ></span>
                      </Link>
                    </li>
                  );
                })}
              </div>
            ) : null}
            {autoComplete.data[1].hits.length ? (
              <div>
                <p className="sections">카탈로그 번호</p>
                {autoComplete.data[1].hits.map((data, idx) => {
                  const isSelected = currentIndex === selectedIndex;
                  // eslint-disable-next-line no-plusplus
                  currentIndex++;
                  return (
                    // eslint-disable-next-line react/no-array-index-key
                    <li
                      key={`${idx}-${data.fk_product_id}`}
                      className={`data ${isSelected ? 'selected' : ''}`}
                      onMouseEnter={() =>
                        this.handleMouseEnter(autoComplete.data[0].hits.length + idx)
                      }
                    >
                      <Link
                        className="wrapper"
                        onClick={() => this.props.goProduct(data.fk_product_id, data.part_number)}
                      >
                        <span
                          className="title"
                          dangerouslySetInnerHTML={{ __html: data._formatted.part_number }}
                        ></span>
                        <br />
                        <span
                          className="cas-number"
                          dangerouslySetInnerHTML={{ __html: data._formatted.cas_number }}
                        ></span>
                      </Link>
                    </li>
                  );
                })}
              </div>
            ) : null}
            {autoComplete.data[2].hits.length ? (
              <div>
                <p className="sections">카테고리</p>
                {autoComplete.data[2].hits.map((data, idx) => {
                  const isSelected = currentIndex === selectedIndex;
                  // eslint-disable-next-line no-plusplus
                  currentIndex++;
                  return (
                    // eslint-disable-next-line react/no-array-index-key
                    <li
                      key={`${idx}-${data.url_slug}`}
                      className={`data ${isSelected ? 'selected' : ''}`}
                      onMouseEnter={() =>
                        this.handleMouseEnter(
                          autoComplete.data[0].hits.length + autoComplete.data[1].hits.length + idx,
                        )
                      }
                    >
                      <Link
                        className="wrapper"
                        to={`/search?q=&menu=products&facets=${encodeURIComponent(JSON.stringify({ categories: data.name }))}`}
                        onClick={this.props.resetState}
                      >
                        <span
                          className="title"
                          dangerouslySetInnerHTML={{ __html: data._formatted.name }}
                        ></span>
                      </Link>
                    </li>
                  );
                })}
              </div>
            ) : null}
            {autoComplete.data[3].hits.length ? (
              <div>
                <p className="sections">브랜드</p>
                {autoComplete.data[3].hits.map((data, idx) => {
                  const isSelected = currentIndex === selectedIndex;
                  // eslint-disable-next-line no-plusplus
                  currentIndex++;
                  return (
                    // eslint-disable-next-line react/no-array-index-key
                    <li
                      key={`${idx}-${data.url_slug}`}
                      className={`data ${isSelected ? 'selected' : ''}`}
                      onMouseEnter={() =>
                        this.handleMouseEnter(
                          autoComplete.data[0].hits.length +
                            autoComplete.data[1].hits.length +
                            autoComplete.data[2].hits.length +
                            idx,
                        )
                      }
                    >
                      <Link
                        className="wrapper"
                        to={`/search?q=&menu=products&facets=${encodeURIComponent(JSON.stringify({ brand: data.title }))}`}
                        onClick={this.props.resetState}
                      >
                        <span
                          className="title"
                          dangerouslySetInnerHTML={{ __html: data._formatted.title }}
                        ></span>
                      </Link>
                    </li>
                  );
                })}
              </div>
            ) : null}
            {autoComplete.data[4].hits.length ? (
              <div>
                <p className="sections">블로그</p>
                {autoComplete.data[4].hits.map((data, idx) => {
                  const isSelected = currentIndex === selectedIndex;
                  // eslint-disable-next-line no-plusplus
                  currentIndex++;
                  return (
                    // eslint-disable-next-line react/no-array-index-key
                    <li
                      key={`${idx}-${data.url_slug}`}
                      className={`data ${isSelected ? 'selected' : ''}`}
                      onMouseEnter={() =>
                        this.handleMouseEnter(
                          autoComplete.data[0].hits.length +
                            autoComplete.data[1].hits.length +
                            autoComplete.data[2].hits.length +
                            autoComplete.data[3].hits.length +
                            idx,
                        )
                      }
                    >
                      <Link
                        className="wrapper"
                        to={`/@${data.username}/${data.url_slug}`}
                        onClick={this.props.resetState}
                      >
                        <span
                          className="title"
                          dangerouslySetInnerHTML={{ __html: data._formatted.title }}
                        ></span>
                        <br />
                        <span
                          className="part-number"
                          dangerouslySetInnerHTML={{ __html: data._formatted.body }}
                        ></span>
                      </Link>
                    </li>
                  );
                })}
              </div>
            ) : null}
          </div>
        ) : (
          <div className="empty">검색 결과가 없습니다.</div>
        )}
      </div>
    );
  }

  render() {
    return <div className="SearchAutoComplete">{this.renderSearchHistory()}</div>;
  }
}

export default connect(
  (state: State) => ({
    autoComplete: state.search.autoComplete,
  }),
  () => ({}),
)(withRouter(SearchAutoComplete));



// WEBPACK FOOTER //
// ./src/components/search/SearchAutoComplete/SearchAutoComplete.js